(function () {
    'use strict';

    angular.module('app.designMockup', []);
})();